import { render } from "./p-card.vue?vue&type=template&id=9bd74022&scoped=true"
import script from "./p-card.vue?vue&type=script&lang=js"
export * from "./p-card.vue?vue&type=script&lang=js"

import "./p-card.vue?vue&type=style&index=0&id=9bd74022&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd74022"]])

export default __exports__